import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Calendar Heatmap art: the Calendar card's structure (month header, two nav
 * buttons, a 7x4 grid) with every day filled by intensity on a single ramp
 * from grey to the accent, since it shows how much happened, not up or down.
 */
const COLUMN_X = [12, 32, 52, 72, 92, 112, 132]
const ROW_Y = [28, 44, 60, 76]
/** 0 = quiet day, 1 = the busiest day of the month. */
const WEEKS: number[][] = [
  [0.45, 0, 0.3, 0.6, 0.25, 0, 0.5],
  [0, 0.35, 0.7, 0.2, 0.4, 0.55, 0],
  [0.2, 0.4, 0.5, 0.3, 0, 0.65, 0.25],
  [0.3, 0.55, 0, 0.4, 0.6, 0.2, 0.45],
]

function cellFill(score: number): string {
  if (score === 0) return 'hsl(var(--foreground) / 0.08)'
  return `hsl(var(--primary) / ${0.2 + score * 0.6})`
}

export function CalendarHeatmapArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect x={12} y={12} width={56} height={7} rx={3} fill="hsl(var(--foreground) / 0.25)" />
      <rect x={128} y={12} width={8} height={7} rx={2} fill="hsl(var(--foreground) / 0.15)" />
      <rect x={140} y={12} width={8} height={7} rx={2} fill="hsl(var(--foreground) / 0.15)" />
      {WEEKS.map((week, row) =>
        week.map((score, col) => (
          <rect
            key={`${row}-${col}`}
            x={COLUMN_X[col]}
            y={ROW_Y[row]}
            width={16}
            height={12}
            rx={3}
            fill={cellFill(score)}
          />
        )),
      )}
    </svg>
  )
}
